

























































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action, Mutation } from 'vuex-class'
import { BALANCE, USERNAME, LOGOUT } from "../../../modules/auth/store/constants";
import { OPEN_ADDFUNDS } from "../../../modules/add-funds/store/constants";
import PlayerAvatar from '@/shared/components/ui/PlayerAvatar.vue';

@Component({
    components: {
        PlayerAvatar
    },
})
export default class TopBar extends Vue {
    @Getter(USERNAME) userName!: string;
    @Getter(BALANCE) balance!: string;
    @Action(LOGOUT) logout!: Function;
    @Mutation(OPEN_ADDFUNDS) openAddFunds!: Function;

    private handleLogout() {
        this.logout();
        this.$router.push('/');
    }

}
